import axios from "axios";

const metricaApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/metrica`
})

async function servGetmetricas(metricaQuatorze) {
    const response = await metricaApi.get('/resumido', {
        params: { metricaQuatorze }
    })
    return response.data
}

async function servGetmetricasV2() {
    const response = await metricaApi.get('/resumido/v2', {
    })
    return response.data
}

export {
    servGetmetricas,
    servGetmetricasV2
}
